import { useState } from "react";
import { useDispatch } from "react-redux";
import { addAlert } from "src/modules/notification";
import RangeNumberInputComponent from "./rangeNumberInput.component";

function getDefaultRange() {
    return { id: Date.now() + Math.random(), from: "", to: "" };
}

export default function RangeNumberInputContainer({
    selectedMethod,
    onValidate,
    onFieldChange,
    isValidating,
    setValidateRanges,
}) {
    const dispatch = useDispatch();
    const [ranges, setRanges] = useState([getDefaultRange()]);

    const handleRangeChange = (idx, field, value) => {
        setRanges((prev) =>
            prev.map((r, i) =>
                i === idx ?
                    {
                        ...r,
                        [field]:
                            (selectedMethod === "serial_num" && field !== "id")
                                ? value.toUpperCase().replace(/\s+/g, '')
                                : (selectedMethod === "seq_num" && field !== "id")
                                    ? value.replace(/\s+/g, '')
                                    : value
                    }
                    : r
            )
        );
        if (onFieldChange) {
            onFieldChange();
        }
    };

    const handleAddRange = () => {
        setRanges((prev) => [...prev, getDefaultRange()]);
        if (onFieldChange) {
            onFieldChange();
        }
    };

    const handleRemoveRange = (idx) => {
        setRanges((prev) => prev.length > 1 ? prev.filter((_, i) => i !== idx) : prev);

        if (onFieldChange) {
            onFieldChange();
        }
    };

const handleValidate = () => {
    // Check if any range is empty
    if (ranges.some(({ from, to }) => !from.trim() || !to.trim())) {
        if (setValidateRanges) setValidateRanges([]);
        return;
    }

    // Validate each range
    const error = ranges.find(({ from, to }) => {
        if (selectedMethod === "seq_num" || selectedMethod === "serial_num") {
            if (from.length !== to.length) {
                dispatch(
                    addAlert({
                        severity: "error",
                        message: "'From' and 'To' values must have the same length.",
                    })
                );
                return true;
            }
        }
        if (selectedMethod === "seq_num") {
            if (/[a-zA-Z]/.test(from) || /[a-zA-Z]/.test(to)) {
                dispatch(
                    addAlert({
                        severity: "error",
                        message: "Sequence Numbers must contain only numeric characters.",
                    })
                );
                return true;
            }
            if (!(/^\d+$/.test(from) && /^\d+$/.test(to))) {
                dispatch(
                    addAlert({
                        severity: "error",
                        message: "Sequence Numbers must contain only numeric characters.",
                    })
                );
                return true;
            }
            if (parseInt(from, 10) > parseInt(to, 10)) {
                dispatch(
                    addAlert({
                        severity: "error",
                        message: '"From" value cannot be greater than "To" value.',
                    })
                );
                return true;
            }
        } else {
            if (from > to) {
                dispatch(
                    addAlert({
                        severity: "error",
                        message: '"From" value cannot be greater than "To" value.',
                    })
                );
                return true;
            }
            if (selectedMethod === "serial_num") {
                const nonNumericFrom = from.replace(/\d+/g, "");
                const nonNumericTo = to.replace(/\d+/g, "");
                if (nonNumericFrom !== nonNumericTo) {
                    dispatch(
                        addAlert({
                            severity: "error",
                            message: "Serial Number range must have the same prefix and postfix.",
                        })
                    );
                    return true;
                }
            }
        }
        return false;
    });

    if (error) return;

    if (setValidateRanges) setValidateRanges(ranges);
    onValidate(ranges);
};

    const hasEmptyRanges = ranges.some(({ from, to }) => !from.trim() || !to.trim());
    const isValidateDisabled = isValidating || hasEmptyRanges;

    return (
        <RangeNumberInputComponent
          ranges={ranges}
          onRangeChange={handleRangeChange}
          onAddRange={handleAddRange}
          onRemoveRange={handleRemoveRange}
          onValidate={handleValidate}
          isValidating={isValidating}
          isValidateDisabled={isValidateDisabled}
          selectedMethod={selectedMethod}
        />
    );
}
